<template>
    <div
        class="fixed hidden bottom-0 left-0 z-30 w-full py-3 bg-white border-t border-gp-grey-40 no-print max-lg:block">
        <div class="container max-md:px-3.75 grid h-full max-w-lg mx-auto" :class="HABARLAR_ENABLED ? 'grid-cols-4' : 'grid-cols-2'">
            <router-link v-if="HABARLAR_ENABLED" class="icon-nav text-xss" :to="{ name: 'mediaCategories' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconGrid></IconGrid>
                    {{ $t('page.categories') }}
                </div>
            </router-link>
            <router-link v-if="HABARLAR_ENABLED" class="icon-nav text-xss" :to="{ name: 'news' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconNews></IconNews>
                    {{ $t('nav.news') }}
                </div>
            </router-link>
            <router-link class="icon-nav text-xss" :to="{ name: 'medias' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconMedia></IconMedia>
                    {{ $t('nav.media') }}
                </div>
            </router-link>
            <router-link class="icon-nav text-xss relative" :to="{ name: 'businessAccounts' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconBusinessAccounts></IconBusinessAccounts>
                    {{ $t('nav.businessAccounts') }}
                </div>
            </router-link>
        </div>
    </div>
</template>

<script setup>
import IconGrid from '@icons/IconGrid.vue'
import IconMedia from '@icons/IconMedia.vue'
import IconCart from '@icons/IconCart.vue'
import IconNews from '@icons/IconNews.vue'
import IconUser from '@icons/IconUser.vue'
import IconBusinessAccounts from '@icons/IconBusinessAccounts.vue'
import { FEATURE_FLAGS } from '@/constants'

const HABARLAR_ENABLED = FEATURE_FLAGS.HABARLAR
</script>

<style>

</style>
<style scoped>
.router-link-exact-active{
    color: #409DBA;
}
</style>